angular.module("digitalLeasing.module").component("customerClassSurvey", {
  templateUrl: "ng/components/digitalLeasing/financialAppropriateVerification/customerClassSurvey/customerClassSurvey.view.html",
  bindings: {
    model: "=",
    onCategoryChanges: "&",
    validateCheckBox: "&",
    isPostVendita: "=",
    datiAnagCessChanges: "<",
    ccsIsOk: "&",
    ccsIsNotOk: "&"
  },
  controllerAs: "customerClassSurveyCtrl",
  controller: CustomerClassSurveyController
});

function CustomerClassSurveyController(
  $financialApiService,
  $typeDomainService,
  FlagArc,
  $portalService,
  $userService
) {
  var self = this;

  self.$onInit = function () {
    self.$portalService = $portalService;
    self.supportModel = {
      categories: [],
      categoryDescription: "",
      categoriaSelected: {
        categoria: "",
        codiceCategoria: ""
      },
      consensi: [],
      ulterioriDichiarazioni: {
        selected: false
      },
      trasmissioneCartacea: {
        selected: false
      },
      trasmissioneElettronica: {
        selected: false
      }
    }
    if (self.isPostVendita) {

      popolateControlCheckBox();
    }
    if (!self.model.datiAnagCessIncompl) {
      getSurveyCategory();
    }

    // if (self.isPostVendita) {
    //   self.supportModel.categoriaSelected.categoria = self.model.qcc.categoria;
    //   self.supportModel.categoriaSelected.codiceCategoria = self.model.qcc.codiceCategoria;
    // } 
    if (!self.isPostVendita) {
      self.supportModel.categoriaSelected.categoria = self.model.financialCustomer.metadata.categoria;
      self.supportModel.categoriaSelected.codiceCategoria = self.model.financialCustomer.metadata.codiceCategoria;
    }
    if (
      self.model.financialCustomer &&
      self.model.financialCustomer.metadata &&
      self.model.financialCustomer.metadata.riUserG &&
      self.model.financialCustomer.metadata.riUserG.cf
    ) {
      self.cfCustomerIsNaN = isNaN(
        self.model.financialCustomer.metadata.riUserG.cf
      );
    }
    validateCheckComponent();
  };

  self.$onChanges = function (changed) {
    if (changed.datiAnagCessChanges.currentValue) {
      getSurveyCategory();
    }
  }

  self.handleChange = function (value) {
    if (self.isPostVendita) {
      self.onCategoryChanges({
        categoria: value
      });
    } else {
      self.model.financialCustomer.metadata.categoria = value.name;
      self.model.financialCustomer.metadata.codiceCategoria = value.value;
      self.supportModel.categoryDescription = value.description;
      self.onCategoryChanges({
        categoria: self.model.financialCustomer.metadata.codiceCategoria
      });

    }
    validateCheckComponent();
  }

  var getSurveyCategory = function () {
    if (self.isPostVendita) {
      $userService.filterQccOptions(self.model.destinatario)
        .then(function (response) {
          self.supportModel.categories = response.domainList.filter(x => { return x.columnName == 'CATEGORY' });
          self.supportModel.checkList = response.domainList.filter(x => { return x.columnName == 'CHECKBOX' || x.columnName == 'M14' });

          self.supportModel.checkList.forEach(function (element) {
            try {
              element.description = JSON.parse(element.description);
              element.description && element.description.forEach(function (element2, index) {
                Object.assign(element2, { indice: index })
              })
            } catch (e) { }
          })
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          validateCheckComponent()
        })
    } else {
      $financialApiService.filterQccOptions(self.model.financialCustomer)
        .then(function (response) {
          self.supportModel.categories = response.domainList.filter(x => { return x.columnName == 'CATEGORY' });
          self.supportModel.checkList = response.domainList.filter(x => { return x.columnName == 'CHECKBOX' || x.columnName == 'M14' });

          self.supportModel.checkList.forEach(function (element) {
            try {
              element.description = JSON.parse(element.description);
              element.description && element.description.forEach(function (element2, index) {
                Object.assign(element2, { indice: index })
              })
            } catch (e) { }
          })

          var checkConsenso = self.supportModel.checkList.find(x => { return x.columnName == 'M14' })
          var test = self.model.leasingData.preventivo.flagsArc
            .some(function (element) {
              if (checkConsenso && element) {
                return element.name == checkConsenso.name
              } else {
                return true;
              }
            })
          if (!test) {
            self.model.leasingData.preventivo.flagsArc.push(checkConsenso);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          validateCheckComponent()
        })
    }
  }

  self.getType = function (value) {
    return typeof value;
  };

  var popolateControlCheckBox = function () {
    $typeDomainService
      .getDomainSet("CONSENSO_PRECONTRATTUALE", "M14")
      .then(function (response) {
        self.supportModel.consensi.push(response.domainList[0]);
        if (self.isPostVendita && self.model.qcc.consensiOk) {
          self.supportModel.consensi.forEach(function (x) {
            x.selected = true;
          });
        }
      })      
      .finally(function () {
        validateCheckComponent()
      })
  }

  self.check = function (el) {
    el.selected = !el.selected;
    validateCheckComponent();
  }

  var validateCheckComponent = function () {
    var checklist = self.supportModel.checkList || self.supportModel.consensi;

    if (checklist && checklist.length) {
      var test = checklist
        .filter((x) => {
          return x.tableName != "QCC_SSL";
        })
        .every((x) => {
          return x.selected == true;
        });
    } else {
      var test = true;
    }

    self.validateCheckBox({
      validity: test,
    });
    if (test) {
      self.ccsIsOk();
    } else {
      self.ccsIsNotOk();
    }
  };
}
